export default {
    truncateString(str, maxLength) {
        if (str.length <= maxLength) {
            return str;
        }

        let truncatedStr = str.substr(0, maxLength); // Trim the string to the maximum length
        truncatedStr = truncatedStr.substr(0, Math.min(truncatedStr.length, truncatedStr.lastIndexOf(' '))); // Trim to the last word boundary
        truncatedStr += '...'; // Add an ellipsis at the end

        return truncatedStr;
    },

    getDescription(intl, text, type) {
        const mappings = {
            policyTypeDescription: {
                'new': 'Profile_Policy_Vitals.Type.New',
                renewal: 'Profile_Policy_Vitals.Type.Renewal',
                endorsement: 'Profile_Policy_Vitals.Type.Endorsement',
                cancellation: 'Profile_Policy_Vitals.Type.Cancellation',
                reinstatement: 'Profile_Policy_Vitals.Type.Reinstatement',
                audit: 'Profile_Policy_Vitals.Type.Audit',
                takeUp: 'Profile_Policy_Vitals.Type.TakeUp',
                certificate: 'Profile_Policy_Vitals.Type.Certificate',
            },
            policyStatusDescription: {
                none: 'Profile_Policy_Vitals.Status.None',
                incomplete: 'Profile_Policy_Vitals.Status.Incomplete',
                submitted: 'Profile_Policy_Vitals.Status.Submitted',
                abandoned: 'Profile_Policy_Vitals.Status.Abandoned',
                accepted: 'Profile_Policy_Vitals.Status.Accepted',
                quoted: 'Profile_Summary_Header.Badge.Quoted',
                'underwriting Required': 'Profile_Policy_Vitals.Status.UnderwritingRequired',
                referred: 'Profile_Policy_Vitals.Status.Referred',
                'quote Issued': 'Profile_Policy_Vitals.Status.QuoteIssued',
                'bind Requested': 'Profile_Policy_Vitals.Status.BindRequested',
                bound: 'Profile_Policy_Vitals.Status.Bound',
                issued: 'Profile_Policy_Vitals.Status.Issued',
                lost: 'Profile_Policy_Vitals.Status.Lost',
                cancelled: 'Profile_Policy_Vitals.Status.Cancelled',
                deleted: 'Profile_Policy_Vitals.Status.Deleted',
                'quote Accepted': 'Profile_Policy_Vitals.Status.QuoteAccepted',
                quoting: 'Profile_Policy_Vitals.Status.Quoting',
            },
        };

        const translationId = mappings[type][text];
        return translationId ? intl.formatMessage({ id: translationId }) : text;
    },

    GetBrokerageName(brokerageName) {
        return brokerageName || '';
    },

    GetBrokerName(firstName, lastName) {
        const first = firstName || '';
        const last = lastName || '';
        return first && last ? `${first} ${last}` : '';
    },

    FormatDateTime(dateString) {
        if (!dateString) {
            return '';
        }
        const date = new Date(dateString);
        const pad = (n) => n.toString().padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
};
